import { isInternetExplorer } from "../../../utils/helpers";

if (isInternetExplorer) {
  Element.prototype.remove = function() {
    this.parentElement.removeChild(this);
  };
  NodeList.prototype.remove = HTMLCollection.prototype.remove = function() {
    for (var i = this.length - 1; i >= 0; i--) {
      if (this[i] && this[i].parentElement) {
        this[i].parentElement.removeChild(this[i]);
      }
    }
  };
}

if (!String.prototype.includes) {
  (function() {
    "use strict"; // needed to support `apply`/`call` with `undefined`/`null`
    var toString = {}.toString;
    var defineProperty = (function() {
      // IE 8 only supports `Object.defineProperty` on DOM elements
      try {
        var object = {};
        var $defineProperty = Object.defineProperty;
        var result = $defineProperty(object, object, object) && $defineProperty;
      } catch (error) {}
      return result;
    })();
    var indexOf = "".indexOf;
    var includes = function(search) {
      if (this == null) {
        throw TypeError();
      }
      var string = String(this);
      if (search && toString.call(search) == "[object RegExp]") {
        throw TypeError();
      }
      var stringLength = string.length;
      var searchString = String(search);
      var searchLength = searchString.length;
      var position = arguments.length > 1 ? arguments[1] : undefined;
      // `ToInteger`
      var pos = position ? Number(position) : 0;
      if (pos != pos) {
        // better `isNaN`
        pos = 0;
      }
      var start = Math.min(Math.max(pos, 0), stringLength);
      // Avoid the `indexOf` call if no match is possible
      if (searchLength + start > stringLength) {
        return false;
      }
      return indexOf.call(string, searchString, pos) != -1;
    };
    if (defineProperty) {
      defineProperty(String.prototype, "includes", {
        value: includes,
        configurable: true,
        writable: true
      });
    } else {
      String.prototype.includes = includes;
    }
  })();
}

export var scrollIntoView = (function() {
  // Original implementation is used for backwards compatibility
  var scrollIntoView_original = Element.prototype.scrollIntoView;

  function scrollIntoView(options) {
    // Use traditional scrollIntoView when traditional argument is given.
    if (options === undefined || options === true || options === false) {
      scrollIntoView_original.apply(this, arguments);
      return;
    }

    var window = this.ownerDocument.defaultView;

    // Read options.
    if (options === undefined) options = {};
    if (options.center === true) {
      options.vertical = 0.5;
      options.horizontal = 0.5;
    } else {
      if (options.block === "start") options.vertical = 0.0;
      else if (options.block === "end") options.vertical = 0.0;
      else if (options.vertical === undefined) options.vertical = 0.0;

      if (options.horizontal === undefined) options.horizontal = 0.0;
    }

    // Fetch positional information.
    var rect = this.getBoundingClientRect();

    // Determine location to scroll to.
    var targetY =
      window.scrollY +
      rect.top -
      (window.innerHeight - this.offsetHeight) * options.vertical;
    var targetX =
      window.scrollX +
      rect.left -
      (window.innerWidth - this.offsetWidth) * options.horizontal;

    // Scroll.
    window.scroll(targetX, targetY);

    // If window is inside a frame, center that frame in the parent window. Recursively.
    if (window.parent !== window) {
      // We are inside a scrollable element.
      var frame = window.frameElement;
      scrollIntoView.call(frame, options);
    }
  }

  // Add a method that replaces the browser's implementation.
  function installPolyfill() {
    Element.prototype.scrollIntoView = scrollIntoView;
  }
  scrollIntoView.installPolyfill = installPolyfill;

  return scrollIntoView;
})();

String.prototype.capitalizeFirstLetter = function() {
  return this.replace(/\b\w/g, l => l.toUpperCase());
};

export let handleExceptionWhenLocalstorageDoesntExist = () => {
  (function() {
    var Storage = function(type) {
      function createCookie(name, value, days) {
        var date, expires;

        if (days) {
          date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          expires = "; expires=" + date.toGMTString();
        } else {
          expires = "";
        }
        document.cookie = name + "=" + value + expires + "; path=/";
      }

      function readCookie(name) {
        var nameEQ = name + "=",
          ca = document.cookie.split(";"),
          i,
          c;

        for (i = 0; i < ca.length; i++) {
          c = ca[i];
          while (c.charAt(0) == " ") {
            c = c.substring(1, c.length);
            2480;
          }

          if (c.indexOf(nameEQ) == 0) {
            return c.substring(nameEQ.length, c.length);
          }
        }
        return null;
      }

      function setData(data) {
        // Convert data into JSON and encode to accommodate for special characters.
        data = encodeURIComponent(JSON.stringify(data));
        // Create cookie.
        if (type == "session") {
          createCookie(getSessionName(), data, 365);
        } else {
          createCookie("localStorage", data, 365);
        }
      }

      function clearData() {
        if (type == "session") {
          createCookie(getSessionName(), "", 365);
        } else {
          createCookie("localStorage", "", 365);
        }
      }

      function getData() {
        // Get cookie data.
        var data =
          type == "session"
            ? readCookie(getSessionName())
            : readCookie("localStorage");
        // If we have some data decode, parse and return it.
        return data ? JSON.parse(decodeURIComponent(data)) : {};
      }

      function getSessionName() {
        // If there is no name for this window, set one.
        // To ensure it's unquie use the current timestamp.
        if (!window.name) {
          window.name = new Date().getTime();
        }
        return "sessionStorage" + window.name;
      }

      // Initialise if there's already data.
      var data = getData();

      return {
        length: 0,
        clear: function() {
          data = {};
          this.length = 0;
          clearData();
        },
        getItem: function(key) {
          return data[key] === undefined ? null : data[key];
        },
        key: function(i) {
          // not perfect, but works
          var ctr = 0;
          for (var k in data) {
            if (ctr == i) return k;
            else ctr++;
          }
          return null;
        },
        removeItem: function(key) {
          delete data[key];
          this.length--;
          setData(data);
        },
        setItem: function(key, value) {
          data[key] = value + ""; // forces the value to a string
          this.length++;
          setData(data);
        }
      };
    };

    // Replace window.localStorage and window.sessionStorage with out custom
    // implementation.
    var localStorage = new Storage("local");
    var sessionStorage = new Storage("session");
    var isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(
      navigator.userAgent
    );
    if (isSafari) {
      // For Safari private browsing need to also set the proto value.
      window.localStorage.__proto__ = localStorage;
      window.sessionStorage.__proto__ = sessionStorage;
    } else {
      window.localStorage = localStorage;
      window.sessionStorage = sessionStorage;
    }
  })();
};
if (process.env.NODE_ENV != "test") {
  try {
    // Test webstorage existence.
    if (!window.localStorage || !window.sessionStorage) throw "exception";
    // Test webstorage accessibility - Needed for Safari private browsing.
    sessionStorage.setItem("storage_test", 1);
    localStorage.removeItem("storage_test");
  } catch (e) {
    handleExceptionWhenLocalstorageDoesntExist();
  }
}
